import * as React from 'react';
import { isNullOrUndefined } from 'util';
import { Utils, DateFormatter, domain, domainVal, UiUtils, i18n, isAuth, NumberFormatter, } from 'arm-common';


class UtilisLogin {
    constructor() {
        this.componentName = "[UtilisLogin.js] ";
    }
	
	checkPassword(text) {
        let validation = new Map();
        
        if(!this.checkIfOneSpecialChar(text)){
			validation.set('newPassword', 'Attenzione: almeno 1 carattere speciale'); 
		}
        
        if (!this.checkIfOneLowercase(text)) {
            validation.set('newPassword', 'Attenzione: almeno 1 minuscolo');
            
           
        }
        
        if (!this.checkIfOneDigit(text)) {
            validation.set('newPassword', 'Attenzione: almeno 1 numero');
            

        }

        if (!this.checkIfOneUppercase(text)) {
            validation.set('newPassword', 'Attenzione: almeno 1 maiuscolo');
            
            
        }
		
        if (!this.checkIfEightChar(text)) {
            validation.set('newPassword', 'Attenzione: minimo 8 caratteri');
            
            
        }
        
        return validation;
    }

    checkIfEightChar(text) {
        return text.length >= 8;
    }

    checkIfOneLowercase(text) {
        return /[a-z]/.test(text);
    }

    checkIfOneUppercase(text) {
        return /[A-Z]/.test(text);
    }

    checkIfOneDigit(text) {
        return /[0-9]/.test(text);
    }

    checkIfOneSpecialChar(text) {
        return /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(text);
    }

   


}


export default UtilisLogin = new UtilisLogin;